import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import {ModelService} from '../../../services/model-service';
import {SelectionUtils} from '../../selection-utils';
import {ConfigurationSection, UserStateService} from '../../../services/user-state.service';
import { FormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-mini-restora-mod-secondary-valve-package',
    templateUrl: './mini-restora-mod-secondary-valve-package.component.html',
    styleUrls: ['./mini-restora-mod-secondary-valve-package.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule]
})
export class MiniRestoraModSecondaryValvePackageComponent implements OnChanges {
  private modelService = inject(ModelService);
  private userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  connectionSizeSelection!: GuruEntity;
  motorizedControlValveSelection!: GuruEntity;
  riserConnectionSupplySelection!: GuruEntity;
  riserConnectionReturnSelection!: GuruEntity;
  flowControlSelection!: GuruEntity;
  normallyOpenSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.SECONDARY_VALVE_PACKAGE;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.connectionSizeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSecondaryValveSize');
    this.motorizedControlValveSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSecondaryControlValve');
    this.riserConnectionSupplySelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSecondarySupRiserConn');
    this.riserConnectionReturnSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSecondaryRetRiserConn');
    this.flowControlSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSecondaryRetFlow');
    this.normallyOpenSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USNOvalve2');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
